import { lazy } from "react";

const WorkItemList = lazy(() =>
  import("./WorkItemList").then((m) => ({ default: m.WorkItemList })),
);
const WorkItemCreate = lazy(() =>
  import("./WorkItemCreate").then((m) => ({ default: m.WorkItemCreate })),
);
const WorkItemEdit = lazy(() =>
  import("./WorkItemEdit").then((m) => ({ default: m.WorkItemEdit })),
);

export default {
  list: WorkItemList,
  create: WorkItemCreate,
  edit: WorkItemEdit,
  recordRepresentation: "title",
};
